import * as z from "zod";
import type { IFormFieldsVariables } from "@/types/app";
import { Pages } from "@/constants/enums";
import { signinSchema, signupSchema } from "@/validations/auth";
import { loginSchema } from "@/validations/login";
import {
  forgotPasswordSchema,
  resetPasswordSchema,
} from "@/validations/password-reset";
import { userSchema } from "@/validations/user";

type ValidationSchema =
  | typeof signinSchema
  | typeof signupSchema
  | typeof loginSchema
  | typeof forgotPasswordSchema
  | typeof resetPasswordSchema
  | typeof userSchema
  | z.ZodObject<Record<string, never>>;

const useFormValidations = (
  props: IFormFieldsVariables,
): {
  getValidationSchema: () => ValidationSchema;
} => {
  const { slug } = props;

  const getValidationSchema = () => {
    switch (slug) {
      case Pages.SIGNIN:
        return signinSchema;
      case Pages.SIGNUP:
        return signupSchema;
      case Pages.USERS:
        return userSchema;
      case Pages.LOGIN:
        return loginSchema;
      case Pages.FORGOT_PASSWORD:
        return forgotPasswordSchema;
      case Pages.RESET_PASSWORD:
      case Pages.SET_PASSWORD:
        return resetPasswordSchema;

      default:
        return z.object({});
    }
  };

  return { getValidationSchema };
};

export default useFormValidations;
